// Member categories, a customer journey setting (slice 2, doc 13 §4). Children
// of the customerCategoryHomes route in administrationModuleRoutes. No
// meta.section: that would switch on the legacy maker-checker header.
const customerCategoryRoutes = [
    {
        name: "customerCategoryHome",
        path: "",
        component: () => import("./ListCustomerCategories.vue"),
        meta: {
            auth: true,
            title: "Member Categories",
            breadcrumb: "Member Categories",
            permission: ["view customercategory", "create customercategory", "update customercategory", "delete customercategory"],
        },
    },
];

export default customerCategoryRoutes;
